import type { FC } from 'react'

import { PortfolioDetail } from 'components'

const PortfolioDetailPage: FC = () => <PortfolioDetail />

export default PortfolioDetailPage
